/* eslint-disable new-cap */
import React, { useContext } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Input,
  Button,
} from "reactstrap";

// core components
import { useQuery } from "react-query";
import ApiContext from "services/ApiContext";
import ShopContext from "services/ShopContext";
import BasicTable from "views/tables/BasicTable";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../customerService/customerservice.css";
import moment from "moment";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const columns = [
  {
    name: "ID",
    selector: (row) => (
      <div className="m-2">
        <p>{`#${row.ID}`}</p>
      </div>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: "Points Date",
    selector: (row) => (
      <div>
        <p>{moment(row.PointsDate).format("DD/MM/YYYY")}</p>
        {moment(row.PointsDate).format("hh:mm A")}
      </div>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: "Expiry Date",
    selector: (row) => (
      <div>
        {row.ExpiryDate === null ? (
          <p>-</p>
        ) : (
          <p>{moment(row.ExpiryDate).format("DD/MM/YYYY")}</p>
        )}
      </div>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: "Invoice No",
    selector: (row) => (
      <div>{row.InvoiceNo === "" ? <p>-</p> : <p>{row.InvoiceNo}</p>}</div>
    ),
    sortable: true,
    wrap: true,
  },
  {
    name: "Description",
    selector: (row) => row.Description,
    sortable: true,
    wrap: true,
  },
  {
    name: "Points",
    selector: (row) => row.Points,
    sortable: true,
    wrap: true,
  },
  {
    name: "Status",
    selector: (row) => (
      <div>{row.IsExpired !== false ? <p>Expired</p> : <p>Active</p>}</div>
    ),
    sortable: true,
    wrap: true,
  },
];

const ExampleCustomInput = React.forwardRef(
  // eslint-disable-next-line react/prop-types
  ({ value, children, onClick }, ref) => (
    <Input
      ref={ref}
      value={value}
      onClick={onClick}
      placeholder="Date Range for filter"
      className="h-100"
    >
      {children}
    </Input>
  )
);

function LoyaltyInfo() {
  const { userID } = useParams();
  const shopID = useContext(ShopContext).selctShopID.ID;
  const Axios = useContext(ApiContext);

  const [searchQuery, setSearchQuery] = React.useState("");
  const [dateRange, setDateRange] = React.useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [filterDataResult, setFilterDataResult] = React.useState([]);
  const [selectedData, setSelectedData] = React.useState([]);

  const { isLoading, data, isSuccess } = useQuery(
    `/shop/${shopID}/Loyalty/${userID}/history`,
    async () =>
      shopID !== "0" &&
      Axios.get(`/shop/${shopID}/Loyalty/${userID}/history`, {
        params: {
          limitPerPage: "1000000",
        },
      }).then((res) => {
        const reversedData = res.data?.reverse();
        setFilterDataResult(reversedData);
        return res;
      }),
    { refetchOnWindowFocus: false }
  );
  const handleSelectRows = ({ selectedRows }) => {
    setSelectedData(selectedRows);
  };
  const resetFilter = () => {
    setDateRange([null, null]);

    setFilterDataResult(data?.data);
  };

  const filterData = () => {
    if (isSuccess) {
      const finalData = data?.data
        .filter((item) =>
          startDate !== null
            ? new Date(item.PointsDate) >=
              new Date(
                moment(startDate).set({
                  hour: 0,
                  minute: 0,
                  second: 0,
                  millisecond: 0,
                })
              ).getTime()
            : item
        )
        .filter((item) =>
          endDate !== null
            ? new Date(item.PointsDate) <=
              new Date(
                moment(endDate).set({
                  hour: 23,
                  minute: 59,
                  second: 59,
                  millisecond: 999,
                })
              ).getTime()
            : item
        )
        .filter(
          (item) =>
            (item.ID &&
              item.ID.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (item.InvoiceNo &&
              item.InvoiceNo.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      setFilterDataResult(finalData);
    }
  };

  const columnsForTable = [
    "ID",
    "PointsDate",
    "ExpiryDate",
    "InvoiceNo",
    "Description",
    "Points",
    "Status",
  ];

  const exportPDF = (jsondata) => {
    const doc = new jsPDF({ orientation: "landscape", size: "A4" });
    doc.setFontSize(12);

    const bodydata = jsondata.map((d) =>
      columnsForTable.map((e) => {
        let value = d[e];
        if (e === "ID") {
          const logisticText = `${d.DeliveryType} ${d.Courier || ""} ${
            d.TrackingCode || ""
          }`;
          value = logisticText;
        } else if (e === "PointsDate") {
          value = JSON.stringify(
            moment(d.PointsDate).format("DD/MM/YYYY hh:mm A")
          );
        } else if (e === "ExpiryDate") {
          value = JSON.stringify(
            moment(d.ExpiryDate).format("DD/MM/YYYY hh:mm A")
          );
        } else if (e === "InvoiceNo") {
          value = JSON.stringify(d.InvoiceNo);
        } else if (e === "Description") {
          value = `"RM ${d.Description}"`;
        } else if (e === "Points") {
          value = JSON.stringify(d.Points);
        } else if (e === "Status") {
          value = JSON.stringify(d.IsExpired ? "Expired" : "Active");
        }
        return value;
      })
    );

    autoTable(doc, {
      head: [columns.map((c) => c.name)],
      body: bodydata,
    });
    doc.save("LoyaltyPointStatement.pdf");
  };

  const history = useHistory();
  const handleBackClick = () => {
    history.goBack();
  };

  if (isLoading) {
    return (
      <Col className="text-center" md="12">
        <div className="uil-reload-css reload-background mr-1 align-center">
          <div className="" />
        </div>
      </Col>
    );
  }
  return (
    <div className="content px-3 w-100" style={{ overflowX: "auto" }}>
      <Button
        style={{ backgroundColor: "#51BCDA" }}
        className="mt-2 p-2 ml-5"
        onClick={handleBackClick}
        size="sm"
      >
        Back
      </Button>
      <Card className="card-dark" style={{ minWidth: "350px" }}>
        <CardHeader>
          <CardTitle tag="h4"> Loyalty Point Statement</CardTitle>
        </CardHeader>
        <CardBody>
          <Row xs={1} sm={2} className="my-2">
            <Col>
              <div>Filter Date: </div>
              <div className="d-flex">
                <ReactDatePicker
                  calendarClassName="h-100"
                  wrapperClassName="w-100 "
                  isClearable
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat="dd/MM/yyyy"
                  customInput={<ExampleCustomInput />}
                />
                <Button className="ml-1  my-0" onClick={() => filterData()}>
                  Filter
                </Button>
              </div>
            </Col>
            <Col className="mt-2 mt-sm-0">
              <div>Search: </div>
              <div className="d-flex">
                <Input
                  onChange={(e) => setSearchQuery(e.target.value)}
                  value={searchQuery}
                />
                <Button className="ml-1  my-0" onClick={() => filterData()}>
                  Search
                </Button>
              </div>
            </Col>
          </Row>
          <div className="d-flex align-items-center">
            <span className="mr-2" style={{ fontSize: "16px" }}>
              Filter:
            </span>
            <Button
              className="ml-1"
              color="danger"
              onClick={() => resetFilter()}
            >
              Reset All Filter
            </Button>
          </div>
          <div className="d-flex align-items-center">
            <span className="mr-2" style={{ fontSize: "16px" }}>
              Bulk Action:
            </span>
            <Button
              outline
              color="filter"
              onClick={() =>
                exportPDF(
                  selectedData.length > 0 ? selectedData : filterDataResult
                )
              }
            >
              Export PDF
            </Button>
          </div>

          {isSuccess && data && (
            <div id="" className="mt-5">
              <BasicTable
                pagination
                id=""
                selectableRows
                onSelectedRowsChange={handleSelectRows}
                subHeaderWrap
                progressPending={isLoading}
                data={filterDataResult}
                columns={columns || []}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
}

export default LoyaltyInfo;
